/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateCaseNoteFromEmailRequest
 */
export interface CreateCaseNoteFromEmailRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateCaseNoteFromEmailRequest
     */
    recipientEmail: string;
    /**
     * 
     * @type {string}
     * @memberof CreateCaseNoteFromEmailRequest
     */
    subject: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateCaseNoteFromEmailRequest
     */
    body: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateCaseNoteFromEmailRequest
     */
    originTimeZoneId: string;
}

/**
 * Check if a given object implements the CreateCaseNoteFromEmailRequest interface.
 */
export function instanceOfCreateCaseNoteFromEmailRequest(value: object): value is CreateCaseNoteFromEmailRequest {
    if (!('recipientEmail' in value) || value['recipientEmail'] === undefined) return false;
    if (!('subject' in value) || value['subject'] === undefined) return false;
    if (!('body' in value) || value['body'] === undefined) return false;
    if (!('originTimeZoneId' in value) || value['originTimeZoneId'] === undefined) return false;
    return true;
}

export function CreateCaseNoteFromEmailRequestFromJSON(json: any): CreateCaseNoteFromEmailRequest {
    return CreateCaseNoteFromEmailRequestFromJSONTyped(json, false);
}

export function CreateCaseNoteFromEmailRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateCaseNoteFromEmailRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'recipientEmail': json['recipientEmail'],
        'subject': json['subject'],
        'body': json['body'],
        'originTimeZoneId': json['originTimeZoneId'],
    };
}

export function CreateCaseNoteFromEmailRequestToJSON(json: any): CreateCaseNoteFromEmailRequest {
    return CreateCaseNoteFromEmailRequestToJSONTyped(json, false);
}

export function CreateCaseNoteFromEmailRequestToJSONTyped(value?: CreateCaseNoteFromEmailRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'recipientEmail': value['recipientEmail'],
        'subject': value['subject'],
        'body': value['body'],
        'originTimeZoneId': value['originTimeZoneId'],
    };
}

